import React, {useEffect, useState} from "react";
import {prosLog, startLongQuery, stopLongQuery} from "./ProsConnect";
import LoadingAnimation from "../components/LoadingAnimation";

/**
 * @typedef Props
 * @property {string} queryId
 * @property {string} queryType
 * @property {string} projectId
 * @property {*} queryParams Used to start a long query
 * @property {string} waitText Text shown while executing query
 */

/**
 * Starts a "single triggered" long query and shows wait until completed
 * Calls parent queryCompleted() when query completed (or timed out)
 * @param {Props} props
 */
export default function WaitLongQueryCompletion(props) {
    const [isWaiting, setIsWaiting] = useState(false)

    useEffect(() => {
        setIsWaiting(true)
        prosLog('WaitLongQueryCompletion', props.queryType, "START")

        startLongQuery(props.queryId, props.queryType, props.projectId, (response, isFresh) => {
            prosLog('WaitLongQueryCompletion', props.queryType, "END")
            props.queryCompleted()
        }, props.queryParams)

        return () => stopLongQuery(props.queryId)
    }, [props])

    if (isWaiting) return <LoadingAnimation size="lg" text={props.waitText} mask />
    return null
}

